import React from 'react'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles'

import { IUserInfoResponse } from 'protos'

import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'

import T from 'components/FormattedMessage'

import VitalStatisticsTeam from './VitalStatisticsTeam'
import VitalStatisticsPlayer from './VitalStatisticsPlayer'

export interface Props {
  topTeamScore?: IUserInfoResponse['topTeamScore']
  topPlayerScore?: IUserInfoResponse['topPlayerScore']
}

const styles = (theme: Theme) => createStyles({
  row: {
    height: 55,
    paddingLeft: theme.spacing() * 2,
    paddingRight: theme.spacing() * 2,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const VitalStatistics: React.SFC<InjectedProps> = ({
  classes,
  topTeamScore,
  topPlayerScore,
}) => (
    <>
      <Divider />

      <Grid className={classes.row} direction="column" justify="center" container>
        <Grid item>
          <Typography variant="body1">
            <T id="userprofile_section_stats" />
          </Typography>
        </Grid>
      </Grid>

      {topPlayerScore && (
        <>
          <Divider />
          <Grid className={classes.row} direction="column" justify="center" container>
            <Grid item>
              <VitalStatisticsPlayer topPlayerScore={topPlayerScore} />
            </Grid>
          </Grid>
        </>
      )}

      {topTeamScore && (
        <>
          <Divider />
          <Grid className={classes.row} direction="column" justify="center" container>
            <Grid item>
              <VitalStatisticsTeam topTeamScore={topTeamScore} />
            </Grid>
          </Grid>
        </>
      )}

      <Divider />
    </>
  )

export default withStyles(styles)(VitalStatistics)
